import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';
import { useElevenLabsDisruption } from '../../utils/useElevenLabsDisruption';

const ServiceDisruptionBanner = () => {
  const { t } = useTranslation();
  const isDisrupted = useElevenLabsDisruption();

  if (!isDisrupted) return null;

  // Extra left padding on mobile keeps the text clear of the fixed sidebar toggle.
  return (
    <div
      role="alert"
      className="w-full shrink-0 bg-amber-100 text-amber-900 dark:bg-amber-900 dark:text-amber-50 border-b border-amber-300 dark:border-amber-700 pl-16 pr-4 lg:px-6 py-3 flex items-start gap-3 text-sm"
    >
      <FiAlertTriangle className="w-5 h-5 shrink-0 mt-0.5" aria-hidden="true" />
      <p>{t('serviceDisruptionNotice')}</p>
    </div>
  );
};

export default ServiceDisruptionBanner;
